import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "logo",
  style: {
    "display": "flex",
    "align-items": "center",
    "justify-content": "center"
  }
};
import { useSettingsStore } from '@/store/modules/settings';
import { useUserStore } from '~/src/store/modules/user';

import { storeToRefs } from 'pinia';
import { computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const settingsStore = useSettingsStore();
    const {
      theme,
      logo,
      title
    } = storeToRefs(settingsStore);
    const userStore = useUserStore();
    const homeLink = computed(() => {
      const savedId = localStorage.getItem(`${userStore.userId}${sessionStorage.getItem('belongId')}homeModuleId`);
      return savedId ? {
        path: '/index/index',
        query: {
          id: savedId
        }
      } : {
        path: '/index/index'
      };
    });
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["logo-container", {
          ['logo-container-' + _unref(theme).layout]: true
        }])
      }, [_createVNode(_component_router_link, {
        to: _unref(homeLink)
      }, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_image, {
          style: {
            "width": "35px",
            "height": "40px"
          },
          src: "/logo.png"
        })]), _createElementVNode("span", {
          class: _normalizeClass(["title", {
            'hidden-xs-only': _unref(theme).layout === 'horizontal'
          }])
        }, _toDisplayString(_unref(title)), 3)]),
        _: 1
      }, 8, ["to"])], 2);
    };
  }
});